export function assets(res) {
    return '/assets/' + res;
}

export function scrollOnUpdate() {
    let {
        action
    } = this.state.location;
    
    if (action === 'PUSH') {
        window.scrollTo(0, 0);
    }
}

export const historyState = {
    pushes: 0,
    pops: 0
};



/** WEBPACK FOOTER **
 ** ./src/helpers.ts
 **/